import { defineTileLayerManagerControl, VERSION } from './tile-layer-manager-control.js';

export function createTileLayerManager(L) {
  return defineTileLayerManagerControl(L);
}

export { VERSION };
export const version = VERSION;
export default createTileLayerManager;

if (typeof window !== 'undefined' && window.L && window.L.Control) {
  defineTileLayerManagerControl(window.L);
}
